import React, {useEffect, useState} from "react";

import './EventsTable.scss'
import {useRecoilValue} from "recoil";
import {grpcEventServiceSelector} from "../../state/grpc";
import {
  DataTable,
  DataTableSkeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableHeader,
  TableRow,
  Pagination
} from "@carbon/react";

const EventsTable = () => {
  const eventService = useRecoilValue(grpcEventServiceSelector)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)
  const [events, setEvents] = useState([])
  const [page, setPage] = useState(1)
  const [size, setSize] = useState(25)
  const [totalSize, setTotalSize] = useState(0)

  const headers = [{
    key: 'name', header: 'Nome',
  }, {
    key: 'description', header: 'Descrizione',
  }, {
    key: 'datetime', header: 'Data e ora',
  }, {
    key: 'username', header: 'Utente',
  },];

  useEffect(() => {
    const req = new proto.api.ListEventsRequest()
    const pageReq = new proto.api.PageRequest()
    pageReq.setPage(page)
    pageReq.setSize(size)
    pageReq.setSort("datetime desc")
    req.setPagination(pageReq)
    eventService.listEvents(req, null, (err, resp) => {
      if (err != null) {
        console.error(err)
        setError(true)
      } else {
        const respObj = resp.toObject()
        setEvents(respObj.eventsList)
        setTotalSize(respObj.pagination.total)
      }
      setLoading(false)
    })
  }, [size, page])

  if (loading) {
    return (<DataTableSkeleton
      columnCount={headers.length + 1}
      rowCount={5}
      headers={headers}
    />)
  }

  if (error) {
    return (
      <div>
        <span>ERROR!</span>
      </div>
    )
  }

  const handlePaginationChange = (newPage, newPageSize) => {
    if (newPageSize !== size) {
      setSize(newPageSize);
    }
    if (newPage !== page) {
      setPage(newPage)
    }
  }

  return (
    <DataTable
      rows={events}
      headers={headers}
      render={({
                 rows,
                 headers,
                 getHeaderProps,
                 getRowProps,
                 getTableProps,
                 getTableContainerProps,
               }) => {
        return (
          <TableContainer title="Lista eventi"
                          description="Lista degli eventi accaduti al sistema" {...getTableContainerProps()}>
            <Pagination
              totalItems={totalSize}
              backwardText="Precedente"
              forwardText="Successiva"
              pageSize={size}
              pageSizes={[10, 25, 50, 100]}
              itemsPerPageText="Elementi per pagina"
              pageRangeText={(_current, total) => `di ${total} ${total === 1 ? 'pagina' : 'pagine'}`}
              itemRangeText={(min, max, total) => `${min}–${max} of ${total} elementi`}
              onChange={({page, pageSize}) => handlePaginationChange(page, pageSize)}
            />
            <Table {...getTableProps()}>
              <TableHead>
                <TableRow>
                  {headers.map((header) => (<TableHeader {...getHeaderProps({header})}>
                    {header.header}
                  </TableHeader>))}
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row) => (
                  <TableRow key={row.id} {...getRowProps({row})}>
                    {row.cells.map((cell) => (
                      <TableCell key={cell.id}>
                        {cell.value}
                      </TableCell>
                    ))}
                  </TableRow>))}
              </TableBody>
            </Table>
          </TableContainer>);
      }}
    />
  )
}

export default EventsTable